<template>
    <div>
        <div class="nav">
            <span>刷新</span>
            <span>日期</span>
            <input type="text" />
            <span>至</span>
            <input type="text" />
            <span>搜索</span>
        </div>

        <el-table>
            <el-table-column label="彩种"></el-table-column>
            <el-table-column label="期数"></el-table-column>
            <el-table-column label="发布时间"></el-table-column>
            <el-table-column label="发布技巧师类型"></el-table-column>
            <el-table-column label="EXCEL图表数量"></el-table-column>
            <el-table-column label="销售额"></el-table-column>
            <el-table-column label="提成"></el-table-column>
            <el-table-column label="准确率（自我考核）"></el-table-column>
            <el-table-column label="操作（平台工作人员复核）"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>